import { fireAnalyticsEvent } from '../../event-tracking/helpers/fireAnalyticsEvent'
import isUrl, { IsURLOptions } from 'validator/lib/isURL'

export const isValidUrl = (url: string, options: IsURLOptions = {}): boolean => {
  const length = url.length
  const str1 = url.substring(0, length / 2)
  const str2 = url.substring(length / 2, length)
  const isUrlDoubleCopy = str1 === str2
  const isValid = isUrl(url, { allow_underscores: true, ...options }) && !isUrlDoubleCopy
  if (!isValid) {
    fireAnalyticsEvent('Invalid_URL', { value: url })
  }
  return isValid
}
